import { render, staticRenderFns } from "./AlreadySubmittedSite.vue?vue&type=template&id=1b2f9f60&scoped=true&"
import script from "./AlreadySubmittedSite.vue?vue&type=script&lang=ts&"
export * from "./AlreadySubmittedSite.vue?vue&type=script&lang=ts&"
import style0 from "./AlreadySubmittedSite.less?vue&type=style&index=0&id=1b2f9f60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2f9f60",
  null
  
)

export default component.exports